var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classnames from "classnames";
import { Heading, Link, Paragraph } from "@riseart/common";
import { Card } from "../card/Card";
import { CardContent } from "../card/content/Content";
import { CardMedia } from "../card/media/CardMedia";
import { cardHorizontalCls, cardHorizontalReversedCls, cardHorizontalMediaCls, cardHorizontalContentCls, cardHorizontalContentParagraphCls } from "./Card.less";
function CardHorizontal(_ref) {
  var _ref$name = _ref.name, name = _ref$name === void 0 ? null : _ref$name, _ref$link = _ref.link, link = _ref$link === void 0 ? null : _ref$link, _ref$description = _ref.description, description = _ref$description === void 0 ? null : _ref$description, pictureComponent = _ref.children, _ref$bottomContent = _ref.bottomContent, bottomContent = _ref$bottomContent === void 0 ? null : _ref$bottomContent, className = _ref.className, _ref$reversed = _ref.reversed, reversed = _ref$reversed === void 0 ? false : _ref$reversed;
  return /* @__PURE__ */ React.createElement(Card, {
    className: classnames(cardHorizontalCls, _defineProperty({}, cardHorizontalReversedCls, reversed), className)
  }, /* @__PURE__ */ React.createElement(CardMedia, {
    className: cardHorizontalMediaCls
  }, /* @__PURE__ */ React.createElement(Link, _extends({
    type: "strong",
    title: name
  }, link), pictureComponent)), /* @__PURE__ */ React.createElement(CardContent, {
    className: cardHorizontalContentCls
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: "h3",
    level: "3"
  }, /* @__PURE__ */ React.createElement(Link, _extends({
    type: "strong",
    title: name
  }, link), name)), /* @__PURE__ */ React.createElement(Paragraph, {
    className: cardHorizontalContentParagraphCls
  }, description), bottomContent));
}
__name(CardHorizontal, "CardHorizontal");
export {
  CardHorizontal
};
